import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

var _html, _markdown;

import React, { Fragment } from 'react';
import BlockTypes from '../../../types/BlockTypes';
import groupCellsByTable from '../utils/groupCellsByTable';
import groupCellsByRow from '../utils/groupCellsByRow';
import getTableColumnCountForCells from '../utils/getTableColumnCountForCells';

function HTMLTableCell(_ref) {
  var children = _ref.children;
  return children;
}

export default {
  html: (_html = {}, _defineProperty(_html, BlockTypes.TABLE, function (_ref2) {
    var attributes = _ref2.attributes,
        children = _ref2.children;
    return React.createElement(Fragment, null, Object.entries(groupCellsByTable(children)).map(function (_ref3) {
      var _ref4 = _slicedToArray(_ref3, 2),
          tableId = _ref4[0],
          tableCells = _ref4[1];

      return React.createElement("table", Object.assign({
        key: tableId
      }, attributes), groupCellsByRow(tableCells).map(function (rowCells, key) {
        return React.createElement("tr", {
          key: key
        }, rowCells);
      }));
    }));
  }), _defineProperty(_html, BlockTypes.TABLE_CELL, function (_ref5) {
    var node = _ref5.node,
        attributes = _ref5.attributes,
        children = _ref5.children;
    return React.createElement(HTMLTableCell, {
      node: node
    }, React.createElement("td", attributes, children));
  }), _html),
  markdown: (_markdown = {}, _defineProperty(_markdown, BlockTypes.TABLE, function (_ref6) {
    var node = _ref6.node,
        next = _ref6.next,
        delimiter = _ref6.delimiter;
    var firstLine = Array.from({
      length: getTableColumnCountForCells(node.nodes)
    }, function () {
      return '--';
    }).join('|');
    var table = groupCellsByRow(node.nodes).map(function (rowCells, index) {
      var line = rowCells.map(function (cell) {
        return next(cell);
      }).join('|');

      if (index === 0) {
        return "".concat(line, "\n").concat(firstLine);
      }

      return line;
    }).join('\n');
    return "".concat(table).concat(delimiter);
  }), _defineProperty(_markdown, BlockTypes.TABLE_CELL, function (_ref7) {
    var children = _ref7.children;
    return children.replace('\n', '<br />');
  }), _markdown)
};